var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
    attrs: {
      headers: _vm.headers,
      items: _vm.reservations,
      page: _vm.pagination.page,
      "items-per-page": _vm.paginationReservation.rowsPerPage,
      loading: _vm.loading,
      "loading-text": "",
      search: _vm.searchFromParent,
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page-items": _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.prevIcon,
        nextIcon: _vm.nextIcon,
        "items-per-page-options": _vm.rowsPerPageItems
      }
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationReservation, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationReservation, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableReservationId,
          _vm.paginationReservation.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c("reservations-table-row", {
              attrs: {
                reservation: props.item,
                "can-open-reservation": _vm.userHasPermissionTo("show")
              },
              nativeOn: {
                click: function($event) {
                  return _vm.openReservation(props.item)
                }
              }
            })
          ]
        }
      },
      {
        key: "pageText",
        fn: function(props) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(props.pageStart) +
                " - " +
                _vm._s(props.pageStop) +
                " " +
                _vm._s(_vm.$t("tables.Of")) +
                "\n    " +
                _vm._s(props.itemsLength) +
                "\n  "
            )
          ]
        }
      },
      {
        key: "no-results",
        fn: function() {
          return [
            _c("data-table-no-results", {
              attrs: { search: _vm.searchFromParent }
            })
          ]
        },
        proxy: true
      },
      {
        key: "no-data",
        fn: function() {
          return [
            _vm.loading
              ? _c("div")
              : _vm.isNormalUser && !_vm.workspaceUuid
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "assetReservationManagement.SelectWorkspaceToSeeList"
                        )
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95d79c9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95d79c9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationsTable.vue
// module id = null
// module chunks = 